import React, { useState, useEffect } from 'react';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

const BASE_LEADERBOARD = [
  { name: "StarPlayer99", score: 4800, avatar: "https://images.unsplash.com/photo-1500677404910-8a5f28009d75", avatarAlt: "Young man with short brown hair smiling in casual blue t-shirt outdoors" },
  { name: "PixelQueen", score: 4200, avatar: "https://images.unsplash.com/photo-1621744145908-63c273de1dc4", avatarAlt: "Young woman with long dark hair wearing glasses and white blouse indoors" },
  { name: "GameWizard", score: 3900, avatar: "https://images.unsplash.com/photo-1581629774175-42f704962488", avatarAlt: "Middle-aged man with beard wearing grey hoodie against neutral background" },
  { name: "NeonRunner", score: 3400, avatar: "https://images.unsplash.com/photo-1721637635502-b0abaaa75edb", avatarAlt: "Young woman with curly red hair wearing green jacket in urban setting" },
];

const RANK_COLORS = ['#f59e0b', '#9ca3af', '#cd7c2f'];

export default function Leaderboard({ currentScore, gameId }) {
  const [personalBest, setPersonalBest] = useState(0);

  useEffect(() => {
    try {
      const stored = parseInt(localStorage.getItem(`hs_${gameId}`) || '0');
      setPersonalBest(stored);
    } catch {}
  }, [gameId]);

  useEffect(() => {
    if (currentScore > personalBest) {
      setPersonalBest(currentScore);
    }
  }, [currentScore, personalBest]);

  const displayScore = Math.max(currentScore, personalBest);

  const entries = [
    ...BASE_LEADERBOARD,
    {
      name: "You",
      score: displayScore,
      avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_14a5ca983-1763300171126.png",
      avatarAlt: "Professional man with short black hair in navy blue shirt at office desk",
      isCurrentUser: true,
    },
  ]?.sort((a, b) => b?.score - a?.score)?.map((e, i) => ({ ...e, rank: i + 1 }));

  return (
    <div className="rounded-xl p-4 md:p-5" style={{ background: 'var(--color-card)', border: '1px solid var(--color-border)', boxShadow: 'var(--shadow-md)' }}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Trophy" size={18} color="var(--color-accent)" />
          <h3 className="font-heading font-semibold text-base" style={{ color: 'var(--color-foreground)' }}>
            Leaderboard
          </h3>
        </div>
        {displayScore > 0 && (
          <span className="text-xs px-2 py-0.5 rounded-full" style={{ background: 'rgba(99,102,241,0.1)', color: 'var(--color-primary)', fontFamily: 'var(--font-data)' }}>
            #{entries?.find(e => e?.isCurrentUser)?.rank}
          </span>
        )}
      </div>
      <div className="space-y-2">
        {entries?.map((entry) => (
          <div
            key={entry?.name}
            className="flex items-center gap-3 p-2 rounded-lg transition-colors"
            style={{
              background: entry?.isCurrentUser ? 'rgba(99,102,241,0.1)' : 'transparent',
              border: entry?.isCurrentUser ? '1px solid rgba(99,102,241,0.3)' : '1px solid transparent',
            }}
          >
            <div
              className="w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 font-data text-xs font-bold"
              style={{
                background: entry?.rank <= 3 ? `${RANK_COLORS?.[entry?.rank - 1]}22` : 'var(--color-muted)',
                color: entry?.rank <= 3 ? RANK_COLORS?.[entry?.rank - 1] : 'var(--color-muted-foreground)',
              }}
            >
              {entry?.rank <= 3 ? ['🥇','🥈','🥉']?.[entry?.rank - 1] : entry?.rank}
            </div>
            <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0">
              <Image src={entry?.avatar} alt={entry?.avatarAlt} className="w-full h-full object-cover" />
            </div>
            <span
              className="font-body text-sm flex-1 truncate"
              style={{ color: entry?.isCurrentUser ? 'var(--color-primary)' : 'var(--color-foreground)', fontWeight: entry?.isCurrentUser ? 600 : 400 }}
            >
              {entry?.name}
            </span>
            <span className="font-data text-sm font-semibold whitespace-nowrap" style={{ color: 'var(--color-foreground)' }}>
              {entry?.score?.toLocaleString()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}